import React, { useCallback, useEffect, useState } from 'react';
export const STAGE_WIDTH = 1600;
export const STAGE_HEIGHT = 900;
interface StageProps {
  children: React.ReactNode;
}

/**
 * Fixed 16:9 presentation canvas that scales to fill any desktop viewport.
 * Every slide is authored against a 1600×900 coordinate space so layouts stay
 * pixel-exact on any projector or laptop screen.
 */
export function Stage({
  children
}: StageProps) {
  const [scale, setScale] = useState(1);
  const measure = useCallback(() => {
    const next = Math.min(window.innerWidth / STAGE_WIDTH, window.innerHeight / STAGE_HEIGHT);
    setScale(next);
  }, []);
  useEffect(() => {
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [measure]);
  return <div className="fixed inset-0 grid place-items-center overflow-hidden bg-[#F2F5F3] font-sans antialiased" data-id="element-760" data-mp="fucp2io50v18">
      <div style={{
      width: STAGE_WIDTH,
      height: STAGE_HEIGHT,
      transform: `scale(${scale})`,
      transformOrigin: 'center center',
      flexShrink: 0
    }} className="relative bg-white" data-id="element-761" data-mp="kt60m5jv6byr">
        {children}
      </div>
    </div>;
}